import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const updateAllAcountStatus = (id, params, type) => {
  return Api(
    `${endPoints.updateAllAcountStatus}/${id}?type=${type}`,
    params,
    requestType.PUT
  );
};

const getAllConversation = (params) => {
  return Api(endPoints.getAllConversation, null, requestType.GET);
};

export { updateAllAcountStatus, getAllConversation };
